import { defineStore } from 'pinia'

type State = {
  balance: number,
}

export const useAppStore = defineStore('App', {
  state: (): State => ({
    balance: 0,
  }),
  actions: {
    setBalance (balance: number) {
      this.balance = balance
    },
  },
})
